import type { AdvertisementStatus, Customer, DealResponse, OfferStatus } from '@dobrozem/sdk';
import clsx from 'clsx';
import { isNewStatus } from '@/utils/common';
import { Text } from '../Text';
import styles from './OfferTag.module.scss';
export type TagTypes = 'advertisement' | 'offer' | 'purchase';
const ADVERTISEMENT_STATUS_DICTIONARY: Record<'URGENTLY', string> & Record<AdvertisementStatus, string> & Record<DealResponse['status'], string> & Record<OfferStatus, string> = {
  ACCEPTED: 'Прийнята',
  ACTIVE: 'Активне',
  BLOCKED: 'Заблоковане',
  CANCELED: 'Відхилено',
  CHECKING_DOCUMENTS: 'Перевірка документів',
  DEAL_CANCELED: 'Скасована',
  DEAL_CONCLUDED: 'Угода укладена',
  DEAL_IN_PROGRESS: 'В процесі укладання угоди',
  DEAL_IS_DONE: 'Продано',
  DECLINED: 'Відхилено',
  DELETED: 'Видалено',
  DISCUSSIONS_WITH_TENANT: 'Обговорення з орендарем',
  DOCUMENTS_PROBLEM: 'Проблеми з документами',
  EXPECTING_BUYER_DOCUMENTS_CHECK: 'Очікується перевірка документів покупця',
  EXPECTING_CONTRACT_TO_BE_SIGNED_BY_BUYER: 'Очікується підписання договору покупцем',
  EXPECTING_DOCUMENTS: 'Очікуються документи',
  EXPECTING_SELLER_DOCUMENTS_CHECK: 'Очікується перевірка документів продавця',
  MODERATION_FAILED_INVALID_PROPERTY_TYPE: 'Невірне цільове призначення ділянки',
  MODERATION_FAILED_INVALID_PURPOSE: 'Невірний вид угідь',
  MODERATION_FAILED_NO_CADASTRAL_NUMBER_FOUND: 'Невірний кадастровий номер',
  MODERATION_FAILED_NO_REGISTRY_RESPONSE: 'Помилка отримання даних з регістру',
  NEW: 'Нове',
  NOTARY_SEARCH: 'Пошук нотаріуса',
  ON_MODERATION_AD_UPDATED: 'Оголошення оновлено',
  ON_MODERATION_REGISRTY_DATA_RECEIVED: 'Відредаговано',
  ON_MODERATION_REGISTRY_CHECK_IN_PROGRESS: 'Очікування даних',
  ON_MODERATION_REGISTRY_DATA_INCOMPLETE: 'Неповні дані',
  ON_MODERATION_REGISTRY_TIMEOUT: 'На модерації',
  ON_MODERATRION_REGISTRY_DATA_FAILED: 'Помилка отримання даних',
  URGENTLY: 'Терміново'
};
const colorByStatusAdvertisement: any = {
  ACCEPTED: '#0B8331',
  ACTIVE: '#EAAA00',
  BLOCKED: '#000000',
  DEAL_CANCELED: '#E5E5DC',
  DEAL_IN_PROGRESS: '#0B8331',
  DEAL_IS_DONE: '#C4C4C4',
  DECLINED: '#000000',
  DELETED: '#C4C4C4',
  MODERATION_FAILED_INVALID_PROPERTY_TYPE: '#FF4C2D',
  MODERATION_FAILED_INVALID_PURPOSE: '#FF4C2D',
  MODERATION_FAILED_NO_CADASTRAL_NUMBER_FOUND: '#FF4C2D',
  MODERATION_FAILED_NO_REGISTRY_RESPONSE: '#FF4C2D',
  NEW: '#EAAA00',
  ON_MODERATION_REGISRTY_DATA_RECEIVED: '#FF4C2D',
  ON_MODERATION_REGISTRY_CHECK_IN_PROGRESS: '#0077EB',
  ON_MODERATION_REGISTRY_DATA_INCOMPLETE: '#FF4C2D',
  ON_MODERATION_REGISTRY_TIMEOUT: '#EAAA00',
  ON_MODERATRION_REGISTRY_DATA_FAILED: '#FF4C2D',
  URGENTLY: '#FF4C2D'
};
export const OfferTag = ({
  advertisement,
  className,
  status,
  type = 'advertisement'
  // user,
}: {
  advertisement?: any;
  className?: string;
  status?: any;
  type?: TagTypes;
  user?: Customer | null;
}) => {
  const dictonaryStatus = advertisement?.sellAsap ? ADVERTISEMENT_STATUS_DICTIONARY['URGENTLY'] : (ADVERTISEMENT_STATUS_DICTIONARY as any)[advertisement?.status && isNewStatus(advertisement?.createdAt) ? 'NEW' : advertisement?.status];
  const colorStatus = advertisement?.sellAsap ? colorByStatusAdvertisement['URGENTLY'] : (colorByStatusAdvertisement as any)[advertisement?.status && isNewStatus(advertisement?.createdAt) ? 'NEW' : advertisement?.status];
  if (type === 'offer') {
    return <Text className={clsx(styles.wrapper, className)} color='white' style={{
      backgroundColor: status ? colorByStatusAdvertisement[status] : 'var(--yellow)'
    }} type='p5'>
        {status ? (ADVERTISEMENT_STATUS_DICTIONARY as any)[status] : 'NEW'}
      </Text>;
  }
  if (type === 'purchase') {
    return <Text className={clsx(styles.wrapper, className)} color='white' style={{
      backgroundColor: colorStatus ?? 'var(--yellow)'
    }} type='p5'>
        {advertisement && dictonaryStatus}
      </Text>;
  }

  // if (!user || user.id !== advertisement?.author?.id)

  // if (!user) {
  //   if (advertisement?.sellAsap)
  //     return (
  //       <Text
  //         className={clsx(styles.wrapper, className)}
  //         color='white'
  //         style={{ backgroundColor: `var(--red)` }}
  //         type='p5'
  //       >
  //         Терміново
  //       </Text>
  //     );

  //   return (
  //     <Text
  //       className={clsx(styles.wrapper, className)}
  //       color='white'
  //       style={{ backgroundColor: `var(--yellow)` }}
  //       type='p5'
  //     >
  //       Нове
  //     </Text>
  //   );
  // }

  return <Text className={clsx(styles.wrapper, className)} color='white' style={{
    backgroundColor: colorStatus ?? 'var(--yellow)'
  }} type='p5' data-sentry-element="Text" data-sentry-component="OfferTag" data-sentry-source-file="OfferTag.tsx">
      {advertisement && dictonaryStatus}
    </Text>;
};